<template>
  <MultiSelect
    v-model="selectedItems"
    :options="options"
    optionLabel="label"
    :placeholder="placeholder"
    @change="onChange"
    :filter="filter"
    :showToggleAll="showToggleAll"
    :display="display"
    :scrollHeight="scrollHeight"
    :selectionLimit="selectionLimit"
  />
</template>

<script>
import MultiSelect from 'primevue/multiselect'

export default {
  name: 'CustomMultiSelect',
  components: { MultiSelect },
  props: {
    modelValue: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Select options',
    },
    filter: {
      type: Boolean,
      default: false,
    },
    showToggleAll: {
      type: Boolean,
      default: false,
    },
    display: {
      type: String,
      default: 'comma',
    },
    scrollHeight: {
      type: String,
      default: '200px',
    },
    selectionLimit: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      selectedItems: this.modelValue,
    }
  },
  watch: {
    modelValue(newValue) {
      this.selectedItems = newValue
    },
    selectedItems(newValue) {
      this.$emit('update:modelValue', newValue)
    },
  },
  methods: {
    onChange(event) {
      this.$emit('change', event.value)
    },
  },
}
</script>

<style scoped>
.p-multiselect {
  padding: 6px;
  border-radius: 6px;
}
.p-multiselect .p-multiselect-label {
  padding: 0px !important;
}
</style>
